import { render } from "./QuickstartSection.vue?vue&type=template&id=0690b200"
import script from "./QuickstartSection.vue?vue&type=script&lang=js"
export * from "./QuickstartSection.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__